import * as THREE from 'three';

/** Key directional light with a shadow frustum sized to the fight area. */
export function createLights() {
  const ambient = new THREE.AmbientLight(0x6f7a94, 1.1);

  const key = new THREE.DirectionalLight(0xffffff, 2.2);
  key.position.set(5, 8, 4);
  key.castShadow = true;
  key.shadow.mapSize.set(2048, 2048);
  key.shadow.camera.near = 1;
  key.shadow.camera.far = 30;
  key.shadow.camera.left = -8;
  key.shadow.camera.right = 8;
  key.shadow.camera.top = 8;
  key.shadow.camera.bottom = -8;
  key.shadow.bias = -0.0005;

  return [ambient, key];
}
